import useSWRMutation from "swr/mutation";
import { TypedDocumentString } from "../generated/graphql";
import graphQLFetcher from "../index";

// Hand-written ahead of codegen -- see useDeleteLibertyAIConversation.ts for
// why. Delete this file's local Document/types once
// `renameLibertyAIConversation` ships and codegen generates the real ones.
export interface RenameLibertyAiConversationMutationVariables {
  id: string;
  name: string;
}

export interface RenameLibertyAiConversationMutation {
  __typename?: "Mutation";
  renameLibertyAIConversation: {
    __typename?: "LibertyAIConversation";
    id: string;
    name?: string | null;
  };
}

const RenameLibertyAiConversationDocument = new TypedDocumentString(`
    mutation RenameLibertyAIConversation($id: ID!, $name: String!) {
  renameLibertyAIConversation(id: $id, name: $name) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<
  RenameLibertyAiConversationMutation,
  RenameLibertyAiConversationMutationVariables
>;

export interface UseRenameLibertyAIConversationResponse {
  renameLibertyAIConversation: (
    variables: RenameLibertyAiConversationMutationVariables,
  ) => Promise<RenameLibertyAiConversationMutation | undefined>;
  loading: boolean;
  error: Error | undefined;
}

export function useRenameLibertyAIConversation(): UseRenameLibertyAIConversationResponse {
  const { error, isMutating, trigger } = useSWRMutation<
    RenameLibertyAiConversationMutation,
    Error,
    string,
    RenameLibertyAiConversationMutationVariables
  >(
    "renameLibertyAIConversation",
    async (_key, { arg }: { arg: RenameLibertyAiConversationMutationVariables }) => {
      return graphQLFetcher(RenameLibertyAiConversationDocument, arg);
    },
  );

  return {
    renameLibertyAIConversation: trigger,
    loading: isMutating,
    error,
  };
}
